import Link from 'next/link';
import { useRouter } from 'next/router';

import { IMenuItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';
import Title from '@r1-frontend/entities/Layout/Header/desktop/components/MainMenuItem/components/Title';

import * as ST from './styled';

interface IProps {
    item: IMenuItem,
    onClickHandler: (menuType: 'Main' | 'Right', title: string) => void,
}

const DescriptionLabel = ({ item, onClickHandler }: IProps): JSX.Element => {
    const { asPath } = useRouter();
    const { title, add_desc = '', link, labels = [] } = item;

    return (
        <ST.ItemWrapper isCurrent={asPath === link}>
            <Link
                href={link}
                prefetch={false}
                passHref
            >
                <a
                    onClick={() => onClickHandler('Main', title)}
                    data-test='subitem-link'
                >
                    <ST.TitleRow withLabel={!!labels.length}>
                        <Title title={title}/>
                        {labels.length
                            ? labels.map((label, key) => (
                                <ST.SLabel
                                    key={`${label.title}_${label.id}_${key}`}
                                    textColor={label.color_text}
                                    bgColor={label.color}
                                    data-test='subitem-label'
                                >
                                    {label.title}
                                </ST.SLabel>
                            ))
                            : <></>
                        }
                    </ST.TitleRow>
                    <ST.SDescription description={add_desc}/>
                </a>
            </Link>
        </ST.ItemWrapper>
    );
};

export default DescriptionLabel;
